import { CallNotificationProps, SystemNotification } from '@streem/sdk-react';

export const CallNotification = ({ invitation }: CallNotificationProps): JSX.Element => {
    const userName = invitation?.fromUser?.name ?? 'Unknown';

    return (
        <SystemNotification
            body={`${userName}\nIncoming call`}
            title="Incoming Call"
            iconPath="/favicon.ico"
            onClick={window.focus}
            showNotification={true}
        />
    );
};
